var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress"},[_c('div',{class:'progress-bar progress-bar-'+_vm.type,style:('width: '+_vm.percent+'%')},[_vm._v(_vm._s(_vm.percentLabel)+"%")])])}
var staticRenderFns = []

export { render, staticRenderFns }